import { useMemo } from 'react'
import { Check } from 'lucide-react'
import { useEventPlannerStore } from '../store/eventPlannerStore'

/** Per-zone placed/confirmed counts with a confirm-all-in-zone action. */
export function ZoneConfirmList() {
  const zones = useEventPlannerStore((s) => s.zones)
  const placements = useEventPlannerStore((s) => s.placements)
  const confirmZone = useEventPlannerStore((s) => s.confirmZone)

  const byZone = useMemo(() => {
    const counts = new Map<string, { placed: number; confirmed: number }>()
    for (const p of Object.values(placements)) {
      const c = counts.get(p.areaId) ?? { placed: 0, confirmed: 0 }
      c.placed += 1
      if (p.confirmed) c.confirmed += 1
      counts.set(p.areaId, c)
    }
    return counts
  }, [placements])

  const active = zones.filter((z) => (byZone.get(z.areaId)?.placed ?? 0) > 0)
  if (active.length === 0) {
    return <div className="px-3 py-3 text-center text-[11px] text-white/30">No zones filled yet.</div>
  }

  return (
    <div className="divide-y divide-white/5">
      {active.map((z) => {
        const c = byZone.get(z.areaId)!
        const allConfirmed = c.confirmed === c.placed
        return (
          <div key={z.areaId} className="flex items-center gap-2 px-3 py-2 text-xs">
            <div className="min-w-0 flex-1">
              <div className="truncate font-medium text-white/80">{z.name}</div>
              <div className="text-[10px] text-white/40">
                {c.placed} placed · {c.confirmed} confirmed
              </div>
            </div>
            <button
              type="button"
              onClick={() => confirmZone(z.areaId)}
              disabled={allConfirmed}
              className="flex shrink-0 items-center gap-1 rounded bg-emerald-500/15 px-1.5 py-1 text-[10px] font-medium text-emerald-300 hover:bg-emerald-500/25 disabled:opacity-50"
            >
              <Check className="h-3 w-3" />
              {allConfirmed ? 'Done' : 'Confirm zone'}
            </button>
          </div>
        )
      })}
    </div>
  )
}
